(() => {
  'use strict';

  window.quick_view = { show: false, show_mb: false };
  window.free_shipping_price = 0;

  const couponSelector = [
    '#popup-tool-discount',
    '.cart-tool-discount',
    'coupon-code',
    '.discount-code-field'
  ].join(',');

  function secureExternalLinks(root = document) {
    root.querySelectorAll('a[target="_blank"]').forEach((link) => {
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      rel.add('noreferrer');
      link.setAttribute('rel', Array.from(rel).join(' '));
    });
  }

  function removeUnusedCartTools(root = document) {
    root.querySelectorAll(couponSelector).forEach((element) => element.remove());
    root.querySelectorAll('.previewCartTool').forEach((tool) => {
      if (!tool.querySelector('.cartTool-item')) tool.remove();
    });

    try {
      localStorage.removeItem('storedDiscount');
    } catch (error) {
      // Storage can be unavailable in private browsing.
    }
  }

  function applyCleanup(root = document) {
    secureExternalLinks(root);
    removeUnusedCartTools(root);
  }

  function start() {
    applyCleanup(document);

    const cart = document.querySelector('#halo-cart-sidebar, .halo-cart-sidebar');
    if (cart) {
      const observer = new MutationObserver(() => removeUnusedCartTools(cart));
      observer.observe(cart, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => applyCleanup(event.target));
})();
